import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const pdfUrls = {
    baseUrl: "https://www.nuvamawealth.com/",
    ewweb: "ewwebimages",
    webfile: "/webfiles",
    ebl: "/EBL",
    eblFinancial: "/EBL-Financials",
    announcement: "/2022-23Announcement",
    notice: "/Notices",
    disclaimer: "/disclaimer",
};
export default pdfUrls;
